import {
  faCheckCircle,
  faCircle,
  faTimesCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { ContractStatus } from 'src/apis/contract-management/types';
import { Colors } from 'src/styles';

export const ContractStatusBadge = memo<{
  status: ContractStatus;
}>(({ status }) => {
  switch (status) {
    case 'SUBMITTED':
      return (
        <div>
          <FontAwesomeIcon icon={faCircle} aria-hidden color={Colors.warning} />{' '}
          <span>Submitted</span>
        </div>
      );
    case 'ACTIVATED':
      return (
        <div>
          <FontAwesomeIcon
            icon={faCheckCircle}
            aria-hidden
            color={Colors.success}
          />{' '}
          <span>Activated</span>
        </div>
      );
    case 'CANCELLED':
      return (
        <div>
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          <span>Cancelled</span>
        </div>
      );
    case 'WITHDRAWN':
      return (
        <div>
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          <span>Withdrawn</span>
        </div>
      );
    case 'INACTIVE':
      return (
        <div>
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          <span>Inactive</span>
        </div>
      );
    case 'REJECTED':
      return (
        <div>
          <FontAwesomeIcon
            icon={faTimesCircle}
            aria-hidden
            color={Colors.error}
          />{' '}
          <span>Rejected</span>
        </div>
      );
    case 'PENDING':
      return (
        <div>
          <FontAwesomeIcon icon={faCircle} aria-hidden color={Colors.warning} />{' '}
          <span>Pending</span>
        </div>
      );
    case 'CREATED':
      return (
        <div>
          <FontAwesomeIcon icon={faCircle} aria-hidden color={Colors.warning} />{' '}
          <span>Created</span>
        </div>
      );
  }
});
